<div class="row" *ngIf="userInfo$ | async as userInfo">
  <div class="col-sm-12 filter-bar invoice-list">
    <nav class="navbar m-b-30 p-10">
      <ul class="nav">
        <li class="nav-item">
          <span class="nav-link mr-2 f-16 f-w-600">Ejercicio:</span>
        </li>
        <li class="nav-item mr-5">
            <ng-select [clearable]="false" [items]="ejercicios" [(ngModel)]="ejercicio" (change)="actualizarEjercicio()" bindLabel="label"
            bindValue="value"></ng-select>
        </li>
        <li class="nav-item ml-5" *ngIf="userInfo.rol === roles.administrador">
          <span class="nav-link mr-2 f-16 f-w-600">Generar reporte:</span>
        </li>
        <li class="nav-item" *ngIf="userInfo.rol === roles.administrador">
          <form class="md-float-material" name="f" (ngSubmit)="f.form.valid && generarReporte()" #f="ngForm" novalidate autocomplete="off">
            <div class="row">
              <div class="col">
                <div class="input-group">
                  <input class="form-control" placeholder="Del....." name="fechaInicio" #c1="ngModel" [(ngModel)]="model.fechaInicio" ngbDatepicker #fechaInicio="ngbDatepicker"
                          [minDate]="{year: minAnio, month: minMes, day: minDia}" [maxDate]="{year: maxAnio, month: maxMes, day: maxDia}"
                          (dateSelect)="onSelect($event)" (click)="fechaInicio.toggle()" (keydown)="$event.preventDefault();"
                          [ngClass]="{'is-invalid':f.submitted && c1.invalid}" required>
                  <div class="input-group-append">
                    <button class="btn btn-outline-primary" (click)="fechaInicio.toggle()" type="button">
                      <i class="fas fa-calendar-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="input-group">
                  <input class="form-control" placeholder="Al....." name="fechaFinal" #c2="ngModel" [(ngModel)]="model.fechaFin" ngbDatepicker #fechaFinal="ngbDatepicker"
                          [minDate]="{year: minAnio2, month: minMes2, day: minDia2}"  [maxDate]="{year: maxAnio, month: maxMes, day: maxDia}"
                          (click)="fechaFinal.toggle()" (keydown)="$event.preventDefault();"
                          [ngClass]="{ 'is-invalid':f.submitted && c2.invalid }" required>
                  <div class="input-group-append">
                    <button class="btn btn-outline-primary" type="button" (click)="fechaFinal.toggle()">
                      <i class="fa fa-calendar-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col">
                <button type="submit" class="btn btn-info btn-lg"  [disabled]="!model.fechaInicio || !model.fechaFin">
                  <i class="fas fa-download mr-1"></i> Descargar
                </button>
              </div>
            </div>
          </form>
        </li>
      </ul>
      <div class="nav-item nav-grid" *ngIf="userInfo.rol === roles.administrador">
        <label class="mr-2 f-16 f-w-600">Proceso Electoral</label>
        <div class="switch switch-info d-inline m-r-10">
          <input type="checkbox" id="switch-s-2" (change)="btnChangeEstatus($event)" [checked]="esProceso">
          <label for="switch-s-2" class="cr"></label>
        </div>
      </div>
    </nav>
  </div>
</div>
